var map = {
	"./loading.svg": "885d",
	"./loop-all.svg": "f866",
	"./loop-none.svg": "c3ab",
	"./loop-one.svg": "5527",
	"./lrc.svg": "4713",
	"./menu.svg": "906b",
	"./order-list.svg": "475a",
	"./order-random.svg": "7a1a",
	"./pause.svg": "daf8",
	"./play.svg": "84d8",
	"./right.svg": "bf5c",
	"./skip.svg": "37e7",
	"./volume-down.svg": "bdba",
	"./volume-off.svg": "adec",
	"./volume-up.svg": "4b41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52f0";